export default __webpack_public_path__ + "static/media/ic2.aec4b37d.svg";